export default __webpack_public_path__ + "static/media/Blooded Jerkin of the Golden Horde.0c9d1396.jpg";